import React, { useRef } from "react";
import { MemberPrintTemplate } from "../../components/MemberDetail/MemberPrintTemplate";
import PrintIcon from "../../Images/MemberIconComp/PrintIcon";
import { PageLink } from "../../components/StyledComp/StyledComp";
import { useNavigate, useLocation } from "react-router-dom";
import { useReactToPrint } from "react-to-print";

const PrintMemberDetail: React.FC = () => {
  const componentRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const member = location.state?.member;
  console.log("printMember " + member);
  const handlePrint = useReactToPrint({
      content: () => componentRef.current,
      documentTitle: "Member-detail",
      onAfterPrint: () => alert("Request sent to printer"),
    });
    const inlineStyle = {
      color: "#254C65",
      fontSize: "13px",
      height: "120px",
      pageBreakInside: "avoid" as "auto" | "avoid",
    };

  const handleClose = () => {
    window.close();
  };

  return (
    <div className="dashboard-wrapper" style={{paddingBottom: "1rem", paddingTop: "0.5rem", height: "100%"}}>
      <div className="dashboard-wrapper">
        <div className="dashboard-content-wrapper">
    <div style={{ padding: 24 }}>
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 12, marginBottom: 16 }}>
      <div className="secondary-button" onClick={handlePrint}>
              <PrintIcon height={20} width={20} />
              <span style={{ marginLeft: "5px" }}>Print</span>
            </div>
            <PageLink
              onClick={() => {
                //setAllMembersFlag(false);
                navigate("/member/findmember", { replace: true });
              }}
              style={{ marginBottom: "1rem" }}
            >
              close
            </PageLink>
      </div>
      <div className="printA4Sheet-div, container-fluid" ref={componentRef}>
        <MemberPrintTemplate member={member} />
      </div>
    </div>
    </div>
    </div>
    </div>
  );
};

export default PrintMemberDetail;
